<template>
  <transition name="slide-down">
    <div>
      <a-spin
        :spinning="detailLoading"
        class="spin-absolute-center"
      >
        <div
          v-if="historyDetail && historyDetail.before && Object.keys(historyDetail.before).length"
          class="detail-wrap clearfix"
        >
          <div class="before">
            <h2 class="title">
              <span class="fl">{{ $t('message["50"]') }}</span>
              <span class="fl">{{ $t('message["47"]') }}</span>
            </h2>
            <ul class="detail clearfix">
              <li
                v-for="(one, i) in historyDetail.before"
                :key="i"
                :class="{ 'isdelete': one.isdelete }"
                class="field clearfix"
              >
                <div class="before-item fl">
                  <label class="fl"><span>{{ one.fieldname }}</span>：</label>
                  <change-value
                    :value-key="i"
                    :data="one"
                    history-type="old"
                    class="value"
                  />
                </div>
                <div class="after-item fl">
                  <label class="fl"><span>{{ historyDetail.after[i].fieldname }}</span>：</label>
                  <change-value
                    :value-key="i"
                    :data="historyDetail.after[i]"
                    history-type="new"
                    class="value"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </a-spin>
      <p
        v-if="!detailLoading && !(historyDetail && historyDetail.before && Object.keys(historyDetail.before).length)"
        class="tip"
      >
        {{ $t('message["1544"]') }}
      </p>
    </div>
  </transition>
</template>

<script>
import ChangeValue from './ChangeValue'

export default {
  components: {
    ChangeValue
  },
  props: {
    historyDetail: {
      type: Object,
      default: () => ({ })
    },
    detailLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-wrap {
  .title {
    height: 40px;
    line-height: 40px;
    margin: 0;
    padding: 0 12px;
    background-color: #f5f6f7;
    & > span {
      width: 50%;
    }
  }
  .detail {
    .field {
      padding: 8px 12px;
      border-bottom: solid 1px $gray4;
      &.isdelete {
        border: none;
      }
      .before-item, .after-item {
        width: 50%;
      }
    }
    label {
      width: 80px;
      color: $gray2;
      line-height: 24px;
    }
  }
  .tip {
    padding: 10px 0;
  }
}
</style>
<style lang="scss">
.slide-down-move-enter,
.slide-down-move-leave-active {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

.slide-down-move-enter-active,
.slide-down-move-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>
